export const VISIBILITY_LEVELS = [
  "PUBLIC_AFTER_CLOSE",
  "PUBLIC_AFTER_DATE",
  "PARTICIPANTS_AFTER_CLOSE",
  "PARTICIPANTS_AFTER_DATE",
  "CONTRACTOR_ONLY",
] as const;

export type SurveyVisibilityLevel = (typeof VISIBILITY_LEVELS)[number];

export const DATE_BASED_VISIBILITY_LEVELS: readonly SurveyVisibilityLevel[] = [
  "PUBLIC_AFTER_DATE",
  "PARTICIPANTS_AFTER_DATE",
] as const;

export interface SurveyVisibilityConfig {
  surveyId: string;
  visibilityLevel: SurveyVisibilityLevel;
  disclosureDate: string | null;
}

export interface SurveyVisibilitySummary {
  visibilityLevel: SurveyVisibilityLevel;
  disclosureDate: string | null;
  disclosureRuleText?: string;
  isDateBasedRule: boolean;
  isRestricted: boolean;
  effectiveFromUtc?: string | null;
}

export interface SurveyVisibilityDeniedResponse {
  code:
    | "DENY_NOT_CONTRACTOR"
    | "DENY_NOT_PARTICIPANT"
    | "DENY_SURVEY_NOT_CLOSED"
    | "DENY_DISCLOSURE_DATE_NOT_REACHED"
    | "DENY_SCOPE_ORGANIZATION";
  message: string;
  correlationId?: string;
  visibility: SurveyVisibilitySummary;
}

export interface UpdateSurveyVisibilityRequest {
  visibilityLevel: SurveyVisibilityLevel;
  disclosureDate?: string | null;
}

export function isDateBasedVisibilityLevel(level: SurveyVisibilityLevel): boolean {
  return DATE_BASED_VISIBILITY_LEVELS.includes(level);
}
